import React, { useCallback } from 'react'
import Box from '@material-ui/core/Box'
import chat from '../../../assets/admin/images/chat-icon.svg'
import openIM from '../../../assets/admin/images/openIM.svg'
import liveControlAdmin from '../../../assets/admin/images/live-control-admin.png'
import TopNavComponent from '../navigation/TopNavComponent'
import BattleFieldButton from '../../default/BattleFieldButton'
import allTopNav, { topNavOrder } from '../navigation/topNav'
import allLink from '../navigation/link'
import useT from '../../../i18ns/admin/useT'
import { defaultLanguage } from '../../../enums/default/LanguageType'
import { useDebouncedCallback } from 'use-debounce'
import { useChecker } from '../../../utils/admin/AdminRouteHook'
import { PermissionType } from '@golden/gdk-admin'
import OpenIMAdminButton from '../../default/OpenIMAdminButton'
import LiveControlAdminButton from '../../default/LiveControlAdminButton'
import BattleFieldNextButton from '../../default/BattleFieldNextButton'

const AppBarContent: React.FC = () => {
  const { t, i18n } = useT()
  const lng = i18n.language || defaultLanguage
  const visibleCustomer = useChecker([PermissionType.CUSTOMER_SERVICE_READ])
  const visibleOpenIMAdmin = useChecker([PermissionType.OPEMIM_ADMIN_READ])
  const visibleLiveControlAdmin = useChecker([PermissionType.LIVE_CONTROL_ADMIN_READ])

  const [handleBattleFieldClick] = useDebouncedCallback(useCallback(() => {
    window.open(`${allLink.battleField.href}?lng=${lng}`)
  }, [lng]), 200)
  const [handleBattleFieldNextClick] = useDebouncedCallback(useCallback(() => {
    window.open(allLink.battleFieldNext.href)
  }, []), 200)
  const [handleOpenIMAdminClick] = useDebouncedCallback(useCallback(() => {
    window.open(allLink.openIMAdmin.href)
  }, [lng]), 200)
  const [handleLiveControlAdminClick] = useDebouncedCallback(useCallback(() => {
    window.open(allLink.liveControlAdmin.href)
  }, [lng]), 200)
  return (
    <Box
      display="flex"
      flexGrow={1}
      flexDirection="row"
      justifyContent="flex-end"
      alignItems="flex-end"
      paddingRight={0.5}
    >
      <Box
        display="flex"
        flexDirection="row"
      >
        {topNavOrder.map((topNav) => (
          <TopNavComponent key={topNav} topNav={allTopNav[topNav]} />
        ))}
        {visibleCustomer && (
          <Box paddingX={1}>
            <BattleFieldButton
              text={t('topNav.customerService')}
              icon={chat}
              onClick={handleBattleFieldClick}
            />
          </Box>
        )}
        {visibleCustomer && (
          <Box paddingX={1}>
            <BattleFieldNextButton
              text={t('topNav.newCustomerService')}
              icon={chat}
              onClick={handleBattleFieldNextClick}
            />
          </Box>
        )}
        {visibleOpenIMAdmin && (
          <Box paddingX={1}>
            <OpenIMAdminButton
              text={t('common.openIMAdmin')}
              icon={openIM}
              onClick={handleOpenIMAdminClick}
            />
          </Box>
        )}
        {visibleLiveControlAdmin && (
          <Box paddingX={1}>
            <LiveControlAdminButton
              text={t('common.liveControlAdmin')}
              icon={liveControlAdmin}
              onClick={handleLiveControlAdminClick}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default React.memo(AppBarContent)
